export default __webpack_public_path__ + "static/screeny-110-gc-cabrio-1-9ae96047ddd3b3e7d303107b8e785052.jpg";